window.addEventListener('load', () => {
  const isCollapsed = localStorage.getItem('sidebar-collapsed') || 0;

  if (!document.querySelector('.sidebar')) return;

  // Auto-ouverture/fermeture de la side bar au chargement de la page
  if (isCollapsed === '1') {
    document.querySelector('.sidebar').classList.add('sidebar--collapse');
    document.querySelector('.sidebar').classList.add('sidebar--show');
    document.querySelector('.layout').classList.add('layout--collapse');
  } else {
    document.querySelector('.sidebar').classList.remove('sidebar--collapse');
    document.querySelector('.sidebar').classList.remove('sidebar--show');
    document.querySelector('.layout').classList.remove('layout--collapse');
  }

  // Auto-reinstanciation Leaflet Map au chargement de la page en fonction de la side bar
  setTimeout(() => {
    if (window._map) window._map.invalidateSize();
  }, 250);

  // Auto-resize des graphiques Apache Echarts au chargement de la page en fonction de la side bar
  setTimeout(() => {
    if (!window._echarts) return;

    window._echarts = window._echarts.filter((e) => !e.isDisposed());
    for (let i = 0; i < window._echarts.length; i++)
      window._echarts[i].resize();
  }, 500);
});

window.addEventListener('change-sidebar-visibility', function (event) {
  // Mécanisme de la side bar
  document.querySelector('.sidebar').classList.toggle('sidebar--collapse');
  document.querySelector('.sidebar').classList.toggle('sidebar--show');
  document.querySelector('.layout').classList.toggle('layout--collapse');

  // Enregistrement de l'état de la side bar
  localStorage.setItem(
    'sidebar-collapsed',
    document.querySelector('.sidebar').classList.contains('sidebar--collapse')
      ? 1
      : 0
  );

  // Reinstanciation Leaflet Map en fonction de la side bar
  setTimeout(() => {
    if (window._map) window._map.invalidateSize();
  }, 250);

  //Resize des graphiques Apache Echarts en fonction de la side bar
  setTimeout(() => {
    if (!window._echarts) return;

    window._echarts = window._echarts.filter((e) => !e.isDisposed());
    for (let i = 0; i < window._echarts.length; i++)
      window._echarts[i].resize();
  }, 500);
});
window.addEventListener('change-mobile-sidebar-visibility', function (event) {
  // Mécanisme de la side bar
  document.querySelector('.sidebar').classList.toggle('sidebar--collapse');
  document.querySelector('.sidebar').classList.toggle('sidebar--show');
  document.querySelector('.layout').classList.toggle('layout--collapse');

  // Enregistrement de l'état de la side bar
  localStorage.setItem(
    'sidebar-collapsed',
    document.querySelector('.sidebar').classList.contains('sidebar--collapse')
      ? 1
      : 0
  );

  // Reinstanciation Leaflet Map en fonction de la side bar
  setTimeout(() => {
    if (window._map) window._map.invalidateSize();
  }, 250);

  //Resize des graphiques Apache Echarts en fonction de la side bar
  setTimeout(() => {
    if (!window._echarts) return;

    window._echarts = window._echarts.filter((e) => !e.isDisposed());
    for (let i = 0; i < window._echarts.length; i++)
      window._echarts[i].resize();
  }, 500);
});
